var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc-main",attrs:{"role":"main"}},[_c('div',{staticClass:"main-content"},[_c('main-header'),_c('main-content'),_c('main-aside')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }